import { createAction } from '@reduxjs/toolkit';

export const closeShortTermProjectsView = createAction(
  'shortTermProjects/closeShortTermProjectsView'
);
